import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button1_click(event) {
	$w('#text32').show();
	$w('#button1').hide();
	$w('#button2').show();
	//Add your code for this event here: 
}



/*export function button4_click(event) {
	if ($w('#firstName').value === 'Imagine') {
			wixLocation.to('https://www.questair.co.il/eng-welldone');
			}
	else if ($w('#firstName').value === 'imagine') {
			wixLocation.to('https://www.questair.co.il/eng-welldone');
			}	
	else if ($w('#firstName').value === 'IMAGINE') {
			wixLocation.to('https://www.questair.co.il/eng-welldone');
			}	
	else {
		wixWindow.openLightbox("try");
	}		
	//Add your code for this event here: 
}*/
export function button4_click(event) {
	if ($w('#firstName').value === 'Bird') {
			$w('#box8').show();
			}
	else if ($w('#firstName').value === 'BIRD') {
			$w('#box8').show();
			}	
	else if ($w('#firstName').value === 'bird') {
			$w('#box8').show();
			}
	else if ($w('#firstName').value === 'a bird') {
			$w('#box8').show();
			}
	else if ($w('#firstName').value === 'A bird') {
			$w('#box8').show();
			}		
	else {
		wixWindow.openLightbox("try");
	}		
	//Add your code for this event here: 
}


export function button2_click(event) {
	$w('#text33').show();
	$w('#text32').hide();
	$w('#button2').hide();
	$w('#button3').show();
	//Add your code for this event here: 
}

export function button3_click(event) {
	$w('#button2').hide();
	$w('#button3').hide();
	$w('#text33').hide();
	$w('#text34').show();
	//Add your code for this event here: 
}